module.exports = __webpack_public_path__ + "img/policy.1b07a20.svg";